// import { graphql, useStaticQuery } from 'gatsby';

// const queryCourses = graphql`
//   {
//     gcms {
//       jsonContaniers(where: { name: "HOME_Courses_List_New_V3" }) {
//         content
//       }
//     }
//   }
// `;
export const useCoursesGroupDataV3 = () => {
  // const data = useStaticQuery(queryCourses);
  // return data.gcms.jsonContaniers[0].content;
  const data = {
    mobileGroupCourses: [
      {
        name: '🚀 IELTS cấp tốc',
        levels: ['INT0', 'INT1', 'INT2']
      },
      {
        name: '📚 IELTS cơ bản/nâng cao',
        levels: ['English 101', 'PRE', '4.0', '5.0', '6.0', '6.5', '7.0', 'WS8']
      },
      {
        name: '🏅 SAT',
        levels: ['S.InterV', 'S.InterM', 'S.FdnV', 'S.AdvV', 'S.AdvM', 'S.Scr']
      },
      {
        name: '🎤 TOEIC & TA Giao Tiếp',
        levels: ['AIM 550+', 'AIM 750+', 'PRONUN', 'Talk 101']
      }
    ],
    desktopGroupCourses: [
      {
        name: 'Khóa IELTS cấp tốc',
        levels: ['INT0', 'INT1', 'INT2']
      },
      {
        name: 'Khóa IELTS cơ bản',
        levels: ['PRE', '4.0', '5.0']
      },
      {
        name: 'Khóa IELTS nâng cao',
        levels: ['6.0', '6.5', '7.0', 'WS8']
      },
      {
        name: 'SAT',
        isNew: true,
        levels: ['S.InterV', 'S.InterM', 'S.FdnV', 'S.AdvV', 'S.AdvM', 'S.Scr']
      },
      {
        name: 'TOEIC',
        isNew: true,
        levels: ['AIM 550+', 'AIM 750+']
      },
      {
        name: 'Khóa TA giao tiếp',
        isNew: true,
        levels: ['PRONUN', 'Talk 101']
      },
      {
        name: 'Khóa TOEIC và phát âm',
        levels: ['AIM 550+', 'AIM 750+', 'PRONUN']
      },
      {
        name: 'Khóa GMAT/GRE',
        levels: ['GMAT/GRE.Fdn', 'GMAT/GRE.Adv']
      }
    ]
  };
  return data;
};
